import { Typography } from "antd";

import { GenericOffersTable } from "../../../components/tables/OffersTable";
import { OfferFormGenericForm } from "../../../components/forms/OfferForm";
import OffersService from "../../../services/crud/OfferService";
import Offer from "../../../models/Offer";

function Offers() {
  return (
    <div>
      <Typography.Title level={2}>Offers</Typography.Title>
      <GenericOffersTable></GenericOffersTable>
    </div>
  );
}

export default Offers;
